import { Slide } from '@/components/slides/Slide.tsx';
import { Slide as SlideType } from '@/eventConfig/types.ts';
import { FC } from 'react';
import { SaveSpinner } from '@/components/slides/CheckAndSaveRegistration/SaveSpinner.tsx';

import { OnlineStatusText } from '@/components/slides/CheckAndSaveRegistration/OnlineStatusText.tsx';
import { GridCheckText } from '@/components/slides/CheckAndSaveRegistration/GridCheckText.tsx';
import { TransmitRegistrationText } from '@/components/slides/CheckAndSaveRegistration/TransmitRegistrationText.tsx';
import { ConfirmTransmissionText } from '@/components/slides/CheckAndSaveRegistration/ConfirmTransmissionText.tsx';
import { SaveRegistrationProvider } from '@/saveRegistration/SaveRegistrationProvider.tsx';
import { useSkipOnSupergrid } from '@/util/useSkipOnSupergrid.ts';

interface CheckAndSaveRegistrationProps {
  className?: string;
  slide: SlideType;
}

export const CheckAndSaveRegistration: FC<CheckAndSaveRegistrationProps> = ({ slide, ...rest }) => {
  useSkipOnSupergrid(['skipcheck', 'skipall', 'skipallnumeric']);

  return (
    <SaveRegistrationProvider>
      <Slide slide={slide} {...rest}>
        <div className={'check-grid'}>
          <div>
            <SaveSpinner spinFor={'online-check'} />
          </div>
          <OnlineStatusText slide={slide} />

          <div>
            <SaveSpinner spinFor={'grid-check'} />
          </div>
          <GridCheckText slide={slide} />

          <div>
            <SaveSpinner spinFor={'transmit-registration'} />
          </div>
          <TransmitRegistrationText slide={slide} />

          <div>
            <SaveSpinner spinFor={'confirm-transmission'} />
          </div>
          <ConfirmTransmissionText slide={slide} />
        </div>
      </Slide>
    </SaveRegistrationProvider>
  );
};
